import { Link } from 'react-router-dom';
import type { ApiWish } from '../../types';
import styles from './MobileWishCard.module.css';

interface MobileWishCardProps {
  wish: ApiWish;
}

const MobileWishCard = ({ wish }: MobileWishCardProps) => {
  const getCategoryLabel = (category: string) => {
    const labels: Record<string, string> = {
      '維修': '汽車維修',
      '保養': '汽車保養',
      '美容': '汽車美容',
      '改裝': '汽車改裝',
    };
    return labels[category] || category;
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-TW', {
      month: '2-digit',
      day: '2-digit',
    });
  };

  return (
    <Link to={`/wishes/${wish.id}`} className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>{wish.title}</h3>
        {wish.urgent && (
          <span className={styles.urgentBadge}>急件</span>
        )}
      </div>

      <div className={styles.meta}>
        <span>{wish.region}</span>
        <span>•</span>
        <span>{getCategoryLabel(wish.category)}</span>
      </div>

      <div className={styles.footer}>
        <span className={`${styles.status} ${styles[wish.status]}`}>
          {wish.status === 'open' && '尋找中'}
          {wish.status === 'matched' && '配對中'}
          {wish.status === 'closed' && '已結案'}
        </span>
        <span className={styles.date}>{formatDate(wish.createdAt)}</span>
      </div>
    </Link>
  );
};

export default MobileWishCard;
